import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { inject, Injectable, Injector } from '@angular/core';

import { CustomOverlayRef, ModalSettings } from '@shared/components/overlay/custom-overlay-ref';

import { SearchModalComponent } from '../search-modal.component';

@Injectable({
  providedIn: 'root',
})
export class SearchModalService {
  injector = inject(Injector);
  overlay = inject(Overlay);

  openSearchModal = () => {
    const configs = new OverlayConfig({
      backdropClass: 'cdk-overlay-dark-backdrop',
      hasBackdrop: true,
      panelClass: ['search-modal'],
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });

    const overlayRef = this.overlay.create(configs);

    const customOverlayRef = new CustomOverlayRef<unknown, null, SearchModalComponent>(
      overlayRef,
      false, // no close button
      SearchModalComponent,
      null,
      true, // backdrop click close
      {} as ModalSettings<SearchModalComponent> // empty settings since we don't need the modal wrapper
    );

    overlayRef.attach(
      new ComponentPortal(
        SearchModalComponent,
        null,
        Injector.create({
          parent: this.injector,
          providers: [{ provide: CustomOverlayRef, useValue: customOverlayRef }],
        })
      )
    );

    return customOverlayRef;
  };
}
